import { render, staticRenderFns } from "./primary-button.vue?vue&type=template&id=512c622a&scoped=true&"
import script from "./primary-button.vue?vue&type=script&lang=js&"
export * from "./primary-button.vue?vue&type=script&lang=js&"
import style0 from "./primary-button.vue?vue&type=style&index=0&id=512c622a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512c622a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VHover,VIcon})
